<template>
  <div class="modal_inputs">
    <Tabs :active="activeTab" :class="['mb-4']" :onChange="changeTab" :tabs="tabs" />
    <Tab :id="tabs[0].id" :class="['w-full']" :value="activeTab">
      <form action="false">
        <FormKit
          v-model="values.email"
          input-class="h-10"
          label="Enter the email to anonymize data"
          outer-class="m-0"
          placeholder="Email"
          type="email"
        />
      </form>
    </Tab>
    <Tab :id="tabs[1].id" :value="activeTab">
      <form action="false">
        <FormKit
          v-model="values.seller"
          input-class="h-10"
          label="Choose seller to anonymize data"
          outer-class="m-0"
          placeholder="Seller"
          type="select"
          :options="sellersOptions"
        />
      </form>
    </Tab>
  </div>
  <div class="modal_actions">
    <Button secondaryButton text="Cancel" @click="handleCancel" />
    <Button text="Anonymize" @click="handleSubmitAnonymize" />
  </div>
</template>
<script setup>
import Button from "@/components/UI/Form/Button/Button.vue";
import { useAnonymizeHook } from "@/components/UI/Modal/Bodies/Anonymize/Anonymize.hook";
import Tabs from "@/components/UI/Tabs/Tabs.vue";
import Tab from "@/components/UI/Tabs/Tab.vue";
import { useOptionsStoreActions } from "@/hooks/store/useOptionsStore";
import { onMounted } from "vue";

const { loadSellersOptions, sellersOptions } = useOptionsStoreActions();
const { tabs, values, activeTab, changeTab, handleCancel, handleSubmitAnonymize } =
  useAnonymizeHook();
onMounted(() => {
  loadSellersOptions();
});
</script>
